module.exports = __webpack_public_path__ + "img/welcome.620bfdf6.png";